module.exports = __webpack_public_path__ + "img/Quentin Veillas.863b1ccc.jpg";